import React from 'react';
import { IMAGE_PATHS } from '../config/images';

const SectionSix = () => {
  return (
    <section id="section-six" className="section-six">
      <div className="container">
        <div className="section-six-content">
          <img 
            src={IMAGE_PATHS.sublingual} 
            alt="Aplicação sublingual" 
            className="section-six-img"
          />
          <div className="section-six-text">
            <h2>Adeus cápsulas!</h2>
            <p>O Magrisim foi desenvolvido em gotas para uso por via sublingual, proporcionando uma forma simples, prática, gostosa e confortável de consumo. São apenas <strong>20 gotinhas pela manhã</strong>, sem a necessidade de engolir cápsulas ou comprimidos.</p>
            <p>Quando o consumo é mais fácil, manter a constância também fica mais simples. E a <strong>constância</strong> é um dos fatores mais importantes para quem busca alcançar seus objetivos de emagrecimento.</p>
            <div className="section-six-anvisa-seal">
              <img src={IMAGE_PATHS.anvisa} alt="Selo de aprovação ANVISA" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionSix;
